import "../../styles/city.css";
import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { HiOutlineBuildingStorefront } from "react-icons/hi2";
import { IoClose } from "react-icons/io5";
import { AreaApi } from "api/area.api";
import { LocalStorageUtils } from "utils/localstorage.utils";
import AnalyticsService from "services/analytics.service";
import { EVENT_NAME } from "utils/constants";

const SelectAreaPopup = ({ onClose, hideCloseButton = false }) => {
  const [areaList, setAreaList] = useState([]);
  const selectedAreaId = LocalStorageUtils.getAreaId();

  const fetchAreaList = async () => {
    try {
      const response = await AreaApi.getAreaList();
      setAreaList(response.areas);
      if (response.areas.length === 1 && !selectedAreaId) {
        handleCitySelect(response.areas[0]);
      }
    } catch (error) {
      console.error("Error fetching area list:", error);
    }
  };

  useEffect(() => {
    fetchAreaList();
  }, []);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.1,
      },
    },
  };

  const selectedVariants = {
    unselected: { scale: 1 },
    selected: {
      scale: 1.05,
      transition: {
        type: "spring",
        stiffness: 400,
        damping: 10,
      },
    },
  };

  const handleCitySelect = (area) => {
    LocalStorageUtils.set(LocalStorageUtils.LOCAL_STORAGE_KEY.AREA_ID, area.id);
    LocalStorageUtils.set(
      LocalStorageUtils.LOCAL_STORAGE_KEY.AREA_NAME,
      area.name
    );
    LocalStorageUtils.saveArea(area);
    AnalyticsService.trackEvent(EVENT_NAME.AREA_SELECTED, {
      areaId: area.id,
      areaName: area.name,
    });
    window.location.reload();
  };

  return (
    <div className="city_popup-overlay">
      <motion.div
        className="city_popup-content"
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        transition={{ type: "spring", stiffness: 300, damping: 25 }}
      >
        {!hideCloseButton && (
          <button className="city_popup-close-button" onClick={onClose}>
            <IoClose size={24} />
          </button>
        )}

        <div className="city_popup-container">
          <motion.div className="city_popup-select_you_city_heading">
            Select your Village
          </motion.div>
          <motion.div
            className="city_popup-row"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            {areaList?.map((area) => (
              <motion.div
                key={area.id}
                className={`city_popup-item ${
                  selectedAreaId === area.id ? "city_popup-item-selected" : ""
                }`}
                animate={selectedAreaId === area.id ? "selected" : "unselected"}
                variants={selectedVariants}
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.98 }}
                onClick={() => handleCitySelect(area)}
              >
                <div className="city_popup-icon">
                  <HiOutlineBuildingStorefront />
                </div>
                <div className="city_popup-name">{area.name}</div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
};

export default SelectAreaPopup;
